import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import getStore from '../store';

let analyticsInitialized = false;
let marketingInitialized = false;

function injectScript(src: string, attrs?: Record<string, string>) {
  const el = document.createElement('script');
  el.src = src;
  el.async = true;
  Object.entries(attrs ?? {}).forEach(([k, v]) => el.setAttribute(k, v));
  document.head.appendChild(el);
}

function getReleaseStageFromURL() {
  const { hostname } = window.location;
  if (hostname.includes('staging')) return 'staging';
  if (hostname.includes('herokuapp')) return 'review-app';
  if (hostname === 'www.wren.co') return 'production';
  return 'development';
}

export function initAnalyticsScripts() {
  if (analyticsInitialized) return;
  analyticsInitialized = true;

  Sentry.init({
    dsn:
      getReleaseStageFromURL() === 'development'
        ? undefined
        : 'https://f1c807ea0e314a5e8e2c9b0b6532dcde@o549471.ingest.sentry.io/5672308',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false }),
    ],
    environment: getReleaseStageFromURL(),
    release: window.appVersion,
    allowUrls: [
      'https://www.wren.co/',
      'https://d2fh6tinglf8qi.cloudfront.net',
    ],
    ignoreErrors: [
      'disguiseToken',
      'cancelled',
      'Illegal invocation',
      'Failed to load Stripe.js',
      'Non-Error promise rejection captured',
      'chunk',
      'Failed to fetch',
      'Load failed',
      'TypeError: Load failed',
      'play method is not allowed',
      'ResizeObserver',
      'NetworkError when attempting to fetch resource',
      'Importing a module script failed',
      'Failed to fetch dynamically imported module',
      "Can't find variable: PaymentAutofillConfig",
      'The node before which the new node is to be inserted is not a child of this node',
      'logMutedMessage',
      'Event `CustomEvent` (type=unhandledrejection) captured as promise rejection',
    ],
    beforeSend(event) {
      if (event.exception) {
        try {
          const { user } = getStore().getState();
          Sentry.showReportDialog({
            eventId: event.event_id,
            user: {
              name: String(user.firstName),
              email: String(user.email),
            },
          });
        } catch {
          // No Redux store in Next.js — show dialog without user context
          Sentry.showReportDialog({ eventId: event.event_id });
        }
      }
      return event;
    },
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

  posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY ?? '', {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
    person_profiles: 'identified_only',
    loaded: (ph) => {
      window.posthog = ph;
    },
  });

  injectScript('https://d2fh6tinglf8qi.cloudfront.net/js/script.js', {
    defer: '',
    'data-domain': 'wren.co',
  });
}

export function initMarketingScripts() {
  if (marketingInitialized) return;
  marketingInitialized = true;

  injectScript('https://www.dwin1.com/19038.js', { defer: '' });
  injectScript(
    '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
  );
}

export function isAnalyticsInitialized() {
  return analyticsInitialized;
}
